import * as React from 'react';
import { getImageUrl } from 'helpers/image/getImageUrl';

const noimage =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZmlsbD0iI0FBQUFBQSIgZD0iTTAsNDh2NDE2aDUxMlY0OEgweiBNNDgwLDQzMkgzMlY4MGg0NDhWNDMyeiBNMzUyLDE2MGMwLDI2LjUxLDIxLjQ5LDQ4LDQ4LDQ4czQ4LTIxLjQ5LDQ4LTQ4cy0yMS40OS00OC00OC00OFMzNTIsMTMzLjQ5LDM1MiwxNjB6IE00NDgsNDAwSDY0bDk2LTI1NmwxMjgsMTYwbDY0LTQ4TDQ0OCw0MDB6Ii8+PC9nPjwvc3ZnPg==';

type ImageSize = 800 | 300 | 100;

interface ImageProps {
  src: string;
  size?: ImageSize;
  width?: number;
  height?: number;
  alt?: string;
  title?: string;
}

const Image = ({ src, alt, title }: ImageProps) => {
  const imgUrl = getImageUrl({
    image: src,
  });

  return (
    <img
      src={imgUrl ? imgUrl : noimage}
      alt={alt}
      title={title}
      // onError={(e: any) => {
      //   if (e.target.src !== noimage) {
      //     e.target.src = noimage;
      //   }
      // }}
    />
  );
};

export default Image;
